import * as React from "react";
import { OrderTag } from "utils/enum/orderListFormEnum";
import TagEnhance from "widget/tagEnhance";
// 静态URL
import { EUrl, orderDetailUrl } from "utils/enum/url";
import { AlignItemsProperty, FlexDirectionProperty } from "csstype";

const getOrderTagStyle = width => {
  return {
    padding: "4px 4px",
    width: width - 2 * 8,
    display: "flex",
    flexDirection: "column" as FlexDirectionProperty,
    alignItems: "center" as AlignItemsProperty
  };
};

export default width => {
  return {
    render: (text, record) => {
      // const tags
      // <TagEnhance />;
      let tagList: any = [];

      // 计算tag
      if (record.tags) {
        const tagStrs = record.tags.split(",");
        let index = -1;
        for (const item of OrderTag) {
          index = -1;
          for (const str in tagStrs) {
            if (!tagStrs[str]) continue;
            else if (tagStrs[str] === item.name) {
              index = Number(str);
              tagList.push(item);
              break;
            }
          }
          if (index != -1) {
            tagStrs.splice(index, 1);
            index = -1;
          }
        }
      }

      return (
        <div className="order-tag" style={getOrderTagStyle(width)}>
          <a
            className="list-link"
            href={orderDetailUrl(EUrl.orderDetail, record.id)}
            target="_blank"
            style={{ marginBottom: 4, fontSize: 16 }}
          >
            {text || "-"}
            {/* 根据订单状态Id转换为汉字 */}
            {/* {getOrderStatusStr(text)} */}
          </a>
          <TagEnhance key={record.id} tags={tagList} size={5} />
        </div>
      );
    },
    // 覆盖td样式
    onCell: record => {
      return {
        className: "td-no-padding"
      };
    }
  };
};
